import React from 'react'

const LandingPageNavbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <a className="navbar-brand" href="/"><h2 className='fw-bold'>Aayush <span className='text-secondary'>Srivastava</span></h2></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item mx-3">
                <a className="nav-link active fs-5 fw-semibold" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="/#about">About</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="/all-projects">Projects</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="/#blogs">Blogs</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="/#posts">Posts</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="#contact">Contact</a>
              </li>
            </ul>
            <div className='ms-auto m-2'>
              <a href='#contact'>
                <button className='btn btn-outline-dark rounded-pill fw-medium'>Let's Talk &rarr;</button>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

const ProjectsPageNavbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <a className="navbar-brand" href="/"><h2 className='fw-bold'>Aayush <span className='text-secondary'>Srivastava</span></h2></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link active fs-5 fw-semibold" href="/all-projects">Projects</a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link fs-5 fw-semibold" href="#contact">Contact</a>
              </li>
            </ul>
            <div className='ms-auto m-2'>
              <a href='#contact'>
                <button className='btn btn-outline-dark rounded-pill fw-medium'>Let's Talk &rarr;</button>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

const Navbar = ({page}) => {
  return(
    <div>
      {page === 'landing-page' && <LandingPageNavbar />}
      {page === 'all-projects' && <ProjectsPageNavbar />}
    </div>
  )
}

export default Navbar